import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '../base-component';
import { ApartmentSearchDTO } from '@/model/ApartmentSearchDTO';
import { ApartmentPriceTableColumn } from '@/enums/ApartmentPriceTableColumn';
import { CGReservationStatus } from '@/enums/CGReservationStatus';
import { ApartmentFeature } from '@/enums/ApartmentFeature';
import { ApartmentSearchSortType } from '@/enums/ApartmentSearchSortType';
import { FloorAbbrForTooltip } from '@/enums/FloorAbbrForTooltip';
import { InstanceType } from '@/enums/InstanceType';

@Component
export class ApartmentPriceCard extends BaseComponent {
	@Prop() apartment: ApartmentSearchDTO;
	@Prop() showPackagePrice: boolean;
	@Prop() showPackageInfo: boolean;
	@Prop() showFinalDiscount: boolean;
	@Prop() last: number;
	@Prop() sortType: ApartmentSearchSortType;

	@Prop() hideColumns: ApartmentPriceTableColumn[];

	get completed() {
		return new Date(this.apartment.completionDate) < this.getCurrentDate();
	}

	get isShowApartment() {
		return (
			this.apartment.cgReservationStatus === CGReservationStatus.ShowApartment
		);
	}

	get isSpecialLocationInvest() {
		return (
			this.apartment.locationCatalogNumber == '152' &&
			this.apartment.housingBlockName == 'A'
		);
	}

	get isSpecialLocationName() {
		return (
			this.apartment.locationCatalogNumber == '189' &&
			this.apartment.housingBlockName == 'A'
		);
	}

	get hasPremiumPriceOnRequest() {
		return this.apartment.features.includes(
			ApartmentFeature.PremiumPriceOnRequest
		);
	}

	get isSampleApartment() {
		return this.apartment.cgReservationStatus === 3
	}

	showColumn(column: ApartmentPriceTableColumn) {
		return !this.hideColumns || !this.hideColumns.includes(column);
	}

	showTooltipFloor(floorAbbr: string) {
		return (<any>Object).values(FloorAbbrForTooltip).includes(floorAbbr);
	}

	navigateToApartment() {
		if (this.isShowApartment || this.apartment.sold) {
			return;
		}

		let url = this.apartment.isPremium
			? `//www.central-group.cz/byt-detail-premium.aspx?idByt=${this.apartment.catalogNumber}`
			: `/byt-detail/${this.apartment.catalogNumber}`;

		if (this.$route.query.predbezne && this.$route.query.csh) {
			const joiningChar = url.includes('?') ? '&' : '?';
			url = `${url}${joiningChar}csh=${this.$route.query.csh}&predbezne=${this.$route.query.predbezne}`;
		}

		window.open(url);
	}

	reactive: boolean = true;	// to make isFavorite reactive at least to a change to this variable

	isFavorite(apartment: ApartmentSearchDTO, reactive: boolean) {
		return this.$cookiesService.getFavoriteProducts().includes(apartment.catalogNumber);
	}

	toggleFavorite(catalogNumber: string, to: boolean) {
		this.$cookiesService.setFavoriteProducts(to ? this.$cookiesService.getFavoriteProducts().concat(catalogNumber) : this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.reactive = !this.reactive;
	}

	customBoIdMapping(number: string) {
		return { [InstanceType.Apartment]: number }
	}

	customBoIdMapping1(number: string) {
		return { [InstanceType.HousingBlock]: number }
	}

	packageTooltip() {
		if (this.apartment.packagePriceWithVAT) {
			return this.getText('hidden-price')
		} else if (this.apartment.packageInfo) {
			return this.apartment.packageInfo
		} else if (this.getText('package-price-tooltip') != '') {
			return this.getText('package-price-tooltip')
		}
	}
}

export default ApartmentPriceCard;
